import type { LucideIcon } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function StatCard({
  label, value, icon: Icon, tone, hint,
}: {
  label: string;
  value: string | number;
  icon: LucideIcon;
  tone?: string;
  hint?: string;
}) {
  return (
    <Card className="card-hover">
      <CardContent className="flex items-center justify-between px-5 py-4">
        <div className="min-w-0">
          <div className="num truncate text-2xl font-bold tracking-tight">
            {typeof value === "number" ? value.toLocaleString() : value}
          </div>
          <div className="mt-0.5 truncate text-xs text-muted-foreground" title={hint ?? label}>
            {label}
          </div>
        </div>
        <div className={cn("rounded-lg bg-muted/50 p-2", tone)}>
          <Icon className="h-4 w-4" />
        </div>
      </CardContent>
    </Card>
  );
}
